import { getDefaultClient } from '../../../client/defaultClient';
import { getWalletProviderByKey } from '../getWalletProviderByKey';

type GetConnectedAddressesParams = {
  walletProviderKey: string;
};

/**
 * Retrieves all connected addresses for a specific wallet provider.
 *
 * This function returns the list of wallet addresses that are currently
 * connected and available through the specified wallet provider.
 *
 * @param params.walletProviderKey - The unique key of the wallet provider to query.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An array of connected wallet addresses.
 */
export const getConnectedAddresses = (
  { walletProviderKey }: GetConnectedAddressesParams,
  client = getDefaultClient()
) => {
  const walletProvider = getWalletProviderByKey({ walletProviderKey }, client);

  return walletProvider.getConnectedAddresses();
};
